'use strict';

document.addEventListener('DOMContentLoaded', () => {

    let allArrsReCalc = [], collectArrReCalc = [], maxHeightArrReCalc = [];

    // fix all row heights when theme is switched
    const fixAllRowHeights = (array, container) => {
        const allVerticalRows = container.querySelectorAll('tbody tr.sct-column'),
            allVerticalRowsHeading = container.querySelectorAll('thead tr'),
            containerId = container.getAttribute('id');

        for ( const arr of array ) {
            const allTdHeights = [];
            const verticalRow = container.querySelector('.sct-column-' + arr);

            // check if any of the columns is promoted
            const promoTextVal = verticalRow.querySelector('.promo-text').innerText,
                styles = window.getComputedStyle(verticalRow.querySelector('.promo-text')),
                promoColorVal = styles.getPropertyValue('background-color');

            if ( promoColorVal && promoTextVal ) {
                collectArrReCalc.push(promoColorVal, promoTextVal);
            }

            // for each column,
            const tableCells = verticalRow.querySelectorAll('td');
            const tableCellsTh = allVerticalRowsHeading[0].querySelectorAll('th');

            // first clearup all heigh values
            for ( const cell of tableCells ) {
                cell.style.height = '';
            }
            for ( const cellTh of tableCellsTh ) {
                cellTh.style.height = '';
            }

            // when above finished, calculate new
            for ( const cell of tableCells ) {
                allTdHeights.push(cell.offsetHeight - 18);
            }
            for ( const cellTh of tableCellsTh ) {
                allTdHeights.push(cellTh.offsetHeight - 18);
            }

            // push all values to one array for later processing
            allArrsReCalc.push(allTdHeights);
        }

        // get length of first arr (enough?)
        if (allArrsReCalc.length !== 0) {
            for (let i = 0; i < allArrsReCalc[0].length; i++) {
                const res = allArrsReCalc.map(r => r[i]);
                const data = res.filter(function( element ) {
                   return element !== undefined;
                });
                const maxHeight = Math.max.apply(null, data);

                // push all max heights to array for indexing later
                maxHeightArrReCalc.push(maxHeight + 1);
            }
        }

        // handle headings height
        allVerticalRowsHeading.forEach(row => {
            const tableCells = row.querySelectorAll('th'),
                tableCellsWrap = row.querySelectorAll('th.sct-promo-wrap');

            // first, process all th
            tableCells.forEach((cell, indx) => {
                cell.style['height'] = maxHeightArrReCalc[indx] + 'px';
            });

            // and lastly, check if any of the columns is promoted
            if ( collectArrReCalc.length !== 0 ) {
                tableCellsWrap.forEach((cell, indx) => {
                    cell.style['height'] = maxHeightArrReCalc[indx] + 28 + 'px';
                });
            }

        });

        // handle tbody rows height
        allVerticalRows.forEach(row => {
            const tableCells = row.querySelectorAll('td'),
                tableCellsWrap = row.querySelectorAll('td.sct-promo-wrap');

            // first, process all td
            tableCells.forEach((cell, indx) => {
                cell.style['height'] = maxHeightArrReCalc[indx] + 'px';
            });

            // and lastly, check if any of the columns is promoted
            if ( collectArrReCalc.length !== 0 ) {
                tableCellsWrap.forEach((cell, indx) => {
                    cell.style['height'] = maxHeightArrReCalc[indx] + 28 + 'px';
                });
            }

        });

        // clear all collector arrays
        allArrsReCalc = [];
        collectArrReCalc = [];
        maxHeightArrReCalc = [];
    }

    // there could be multiple tables on one page!
    const tableContainers = document.querySelectorAll('.supreme-table-container');
    tableContainers.forEach(container => {

        let allVerticalRows = container.querySelectorAll('tr.sct-column'),
            allCollectArr = [];

        allVerticalRows.forEach(row => {
            const rowId = row.getAttribute('id');
            allCollectArr.push(rowId);
        });

        // trigger recalc of td heights after 1 sec
        setTimeout(fixAllRowHeights(allCollectArr, container), 1400);

        // clear all collector arrays
        allCollectArr = [];
    });

});